<template>
  <input :value="value" @input="emit" @blur="emit" />
</template>

<script>
export default {
  props: ["value"],
  methods: {
    emit(ev) {
      this.$emit("input", ev.target.value);
    },
  },
};
</script>
